import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import PayixButton from '../../containers/payix-button';

const renderInput = ({input, label, type, htmlFor, maxLength, autoComplete, meta: { touched, error }}) => (
  <div className="form-group">
    <label htmlFor={htmlFor} className="form-group__label">{label}</label>
    <input className="form-group__input" id={htmlFor} {...input} type={type} 
      maxLength={maxLength} autoComplete={autoComplete} />
    {touched && error && <span className="form-group__error">{error}</span>}
  </div>
);

class ForgotPasswordForm extends Component {
  /**
   * Render the component view.
   */
  render() { 
    return (
      <form onSubmit={this.props.handleSubmit}>
        <Field name="contact" type="text" htmlFor="contact" component={renderInput} label="Email Address / Mobile Number" />

        <div className="form-group">
          <PayixButton className="button--full" type="submit">
            SUBMIT
          </PayixButton>
        </div>
      </form>
    )
  }
}

ForgotPasswordForm = reduxForm({
  form: 'forgotPasswordForm'
})(ForgotPasswordForm)
 
export default ForgotPasswordForm;


// WEBPACK FOOTER //
// ./src/components/auth/forgot-password-form.js